import { getCareArticleById, getCareArticles } from 'api/careArticles'
import { pathwayCacheTime } from 'models/pathways.model'
import React, { useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { BaseTableRequest, CareArticleType, EOp } from 'types'
import { selectOptionsFromTableResponse } from 'utils'
import { Option } from '../../form-elements/FormSelect'
import ModalWithSelect from '../simple-modals/ModalWithSelect'

interface Props {
  isOpen: boolean
  handleClose: () => void
  value?: number | null
  onSubmit: (careArticleId: number) => void
}

const LinkToActionPostModal = (props: Props) => {
  const { isOpen, handleClose, value, onSubmit } = props

  const [search, setSearch] = useState('')

  const selectedElementQuery = useQuery(
    ['selectedCareArticleQuery', { value }],
    () => getCareArticleById({ id: value || 0 }),
    {
      enabled: isOpen && value !== null,
      cacheTime: pathwayCacheTime,
    },
  )

  const careArticlesQuery = useQuery(
    ['getCareArticlesForLink', { search }],
    () => {
      const filter: BaseTableRequest['filter'] = {
        isPublished: { type: 'boolean', op: EOp.equals, value: true },
        type: { type: 'text', op: EOp.equals, value: CareArticleType.Task },
      }

      if (search !== '') {
        filter.name = {
          type: 'text',
          op: EOp.contains,
          value: search,
        }
      }

      const request: BaseTableRequest = {
        filter,
        pagination: {
          page: 1,
          pageSize: 500,
        },
        sort: null,
      }

      return getCareArticles(request)
    },
    {
      enabled: isOpen && !selectedElementQuery.isLoading,
      select: selectOptionsFromTableResponse,
      cacheTime: pathwayCacheTime,
    },
  )

  const options = useMemo(() => {
    const base = (careArticlesQuery.data as unknown as Option[]) ?? []
    const selected = selectedElementQuery.data?.data
    if (selected) {
      const el: Option = {
        value: selected.id,
        label: selected.name,
      }
      if (base.some((it) => it.value === selected.id)) {
        return base
      }
      return base.concat(el)
    }
    return base
  }, [careArticlesQuery.data, selectedElementQuery.data?.data])

  return (
    <ModalWithSelect
      value={value}
      title="Change Link to Action Post"
      label="Link to Action Post"
      buttonText="Save"
      isOpen={isOpen}
      handleClose={handleClose}
      onSubmit={onSubmit}
      options={options}
      loading={false}
      loadingOptions={careArticlesQuery.isLoading || selectedElementQuery.isLoading}
      onChangeInput={setSearch}
    />
  )
}

export default React.memo(LinkToActionPostModal)
